export function cbtFormFilled(
  passengersForm,
  allowGuestOnlyReservation = false
) {
  return (
    (allowGuestOnlyReservation
      ? passengersForm.travellers.length + passengersForm.guests > 0
      : passengersForm.travellers.length > 0) &&
    passengersForm.costCenter &&
    passengersForm.travelReason
  );
}

export function cbtPartiallyFilled(passengersForm) {
  return (
    !cbtFormFilled(passengersForm) &&
    passengersForm.wasClosed &&
    (passengersForm.travellers.length !== 0 ||
      passengersForm.guests !== 0 ||
      passengersForm.costCenter ||
      passengersForm.travelReason)
  );
}

export function cbtOnlyFieldsFilled(passengersForm) {
  return passengersForm.costCenter && passengersForm.travelReason;
}
